import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const FeaturesContext = createContext({});

export function FeaturesProvider({ children }) {
  const [features, setFeatures] = useState(null);

  const refresh = () => api.get("/config/features").then(({ data }) => setFeatures(data)).catch(() => {});
  useEffect(() => { refresh(); }, []);

  // null pendant le chargement → on considère tout activé par défaut pour éviter le flash
  const isOn = (flag) => (features == null ? true : !!features[flag]);

  return (
    <FeaturesContext.Provider value={{ features, isOn, refresh }}>
      {children}
    </FeaturesContext.Provider>
  );
}

export function useFeatures() {
  return useContext(FeaturesContext);
}
